export default "__VITE_ASSET__CpZm0tI0__"